<template>
  <v-container fluid fill-height>
    <v-row class="fill-height" no-gutters>
      <v-col :cols="12" :sm="12" :md="12">
        <v-alert
          v-if="message"
          class="mt-4"
          outlined
          :color="successfull ? 'success' : 'error'"
          :icon="successfull ? 'mdi-check-circle' : 'mdi-alert'"
          dismissible
        >
          {{ message }}
        </v-alert>

        <v-card-title>
          <v-row>
            <v-col cols="10" sm="11">
              <h1>Cv Information</h1>
            </v-col>
            <v-col cols="2" sm="1">
              <v-btn v-if="!editing" class="mr-4 mb-2" color="primary" block @click="openEdit">
                Edit
              </v-btn>
              <v-btn v-if="editing" class="mr-2 mb-2" color="secondary" block @click="cancelEdit">
                Cancel
              </v-btn>
              <v-btn
                v-if="editing"
                class="mr-4 mb-2"
                color="primary"
                block
                @click="editInformation"
              >
                Save changes
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-img
                :aspect-ratio="1"
                class="bg-white"
                :src="require('@/assets/user.svg')"
                width="100"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <p v-if="username">{{ username }}</p>
              <p v-else>-</p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-row v-if="!editing">
          <v-col cols="12">
            <v-card-title class="pt-0">
              <h1>Academic information</h1>
            </v-card-title>
            <v-card-text>
              <v-data-table
                v-if="education.length > 0"
                :headers="headersEducation"
                :items="education"
                :items-per-page="5"
                multi-sort
              >
                <template #[itemTitle]="{ item }">
                  <template v-if="item.title">{{ item.title }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemInstitution]="{ item }">
                  <template v-if="item.institution">{{ item.institution }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemDate]="{ item }">
                  <template v-if="item.date">{{ item.date }}</template>
                  <template v-else>-</template>
                </template>
              </v-data-table>
              <p v-else>No academic information</p>
            </v-card-text>
          </v-col>
        </v-row>

        <v-row v-if="!editing">
          <v-col cols="12">
            <v-card-title class="pt-0">
              <h1>Work experience</h1>
            </v-card-title>
            <v-card-text>
              <v-data-table
                v-if="workExperience.length > 0"
                :headers="headersWorkExperience"
                :items="workExperience"
                :items-per-page="5"
                multi-sort
              >
                <template #[itemPosition]="{ item }">
                  <template v-if="item.position">{{ item.position }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemCompany]="{ item }">
                  <template v-if="item.company">{{ item.company }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemPlace]="{ item }">
                  <template v-if="item.place">{{ item.place }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemFunctions]="{ item }">
                  <template v-if="item.functions">
                    {{ item.functions.length }}
                    <v-btn icon :ripple="false" @click="openFunctions(item)">
                      <v-icon size="20" color="primary">mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>-</template>
                </template>
                <template #[itemDuration]="{ item }">
                  <template v-if="item.duration">{{ item.duration }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemDate]="{ item }">
                  <template v-if="item.date">{{ item.date }}</template>
                  <template v-else>-</template>
                </template>
              </v-data-table>
              <p v-else>No work experience</p>
            </v-card-text>
          </v-col>
        </v-row>

        <v-row v-if="!editing">
          <v-col cols="12">
            <v-card-title class="pt-0">
              <h1>Certifications</h1>
            </v-card-title>
            <v-card-text>
              <v-data-table
                v-if="certifications.length > 0"
                :headers="headersCertifications"
                :items="certifications"
                :items-per-page="5"
                multi-sort
              >
                <template #[itemTitleCertifications]="{ item }">
                  <template v-if="item.title">{{ item.title }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemInstitutionCertifications]="{ item }">
                  <template v-if="item.institution">{{ item.institution }}</template>
                  <template v-else>-</template>
                </template>
                <template #[itemDateCertifications]="{ item }">
                  <template v-if="item.date">{{ item.date }}</template>
                  <template v-else>-</template>
                </template>
              </v-data-table>
              <p v-else>No information about certifications</p>
            </v-card-text>
          </v-col>
        </v-row>

        <v-row v-if="!editing">
          <v-col cols="12">
            <v-card-title class="pt-0 mb-4">
              <h1>Skills</h1>
            </v-card-title>
            <v-card-text>
              <v-row v-if="skills.length > 0">
                <v-col v-for="(skill, index) in skills" :key="index" cols="12" sm="6" md="4">
                  <v-list>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-circle-small</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-if="skill.level">
                          {{ skill.name }} (Level: {{ skill.level }})
                        </v-list-item-title>
                        <v-list-item-title v-else>{{ skill.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row v-else>
                <p>No information about skills</p>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="showFunctions" max-width="550" min-height="550">
      <v-card>
        <v-card-title>
          <h5>Functions</h5>
        </v-card-title>
        <v-card-text>
          <v-list color="transparent">
            <v-list-item v-for="(func, index) in itemToShow.functions" :key="index">
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <p>{{ func }}</p>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showFunctions = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="550" min-height="550">
      <v-card>
        <v-card-title>
          <h5>Delete item</h5>
        </v-card-title>
        <v-card-text>
          <p>Do you really want to delete the selected item?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn @click="deleteItem">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CandidatesDataService from '@/services/CandidatesDataService';

export default {
  name: 'CVResults',
  data() {
    return {
      message: '',
      successfull: false,
      education: [],
      workExperience: [],
      certifications: [],
      skills: [],
      languages: [],
      headersEducation: [
        { text: 'Title', value: 'title' },
        { text: 'Institution', value: 'institution' },
        { text: 'Date', value: 'date' },
      ],
      headersEducationEdit: [
        { text: 'Title', value: 'title' },
        { text: 'Institution', value: 'institution' },
        { text: 'Date', value: 'date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersCertifications: [
        { text: 'Title', value: 'title' },
        { text: 'Institution', value: 'institution' },
        { text: 'Date', value: 'date' },
      ],
      headersCertificationsEdit: [
        { text: 'Title', value: 'title' },
        { text: 'Institution', value: 'institution' },
        { text: 'Date', value: 'date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersWorkExperience: [
        { text: 'Position', value: 'position' },
        { text: 'Company', value: 'company' },
        { text: 'City', value: 'place' },
        { text: 'Functions', value: 'functions' },
        { text: 'Duration', value: 'duration' },
        { text: 'Date', value: 'date' },
      ],
      headersWorkExperienceEdit: [
        { text: 'Position', value: 'position' },
        { text: 'Company', value: 'company' },
        { text: 'City', value: 'place' },
        { text: 'Duration', value: 'duration' },
        { text: 'Date', value: 'date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersSkillsEdit: [
        { text: 'Name', value: 'name' },
        { text: 'Level', value: 'level' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      itemToShow: {},
      showFunctions: false,
      username: '',
      editing: false,
      rules: [(v) => !!v || 'Required field'],
      itemToEdit: {
        education: [],
        work_experience: [],
        certificates: [],
        tools_and_skills: [],
      },
      type: '',
      itemToDelete: {},
      deleteDialog: false,
    };
  },
  computed: {
    itemTitle() {
      return `item.title`;
    },
    itemInstitution() {
      return `item.institution`;
    },
    itemDate() {
      return `item.date`;
    },
    itemTitleCertifications() {
      return `item.title`;
    },
    itemInstitutionCertifications() {
      return `item.institution`;
    },
    itemDateCertifications() {
      return `item.date`;
    },
    itemPosition() {
      return `item.position`;
    },
    itemCompany() {
      return `item.company`;
    },
    itemPlace() {
      return `item.place`;
    },
    itemFunctions() {
      return `item.functions`;
    },
    itemDuration() {
      return `item.duration`;
    },
    itemNameSkills() {
      return `item.name`;
    },
    itemLevelSkills() {
      return `item.level`;
    },
  },
  watch: {
    '$route.params.cv': {
      handler(newCv) {
        if (newCv) {
          this.getCV();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getCV();
  },
  methods: {
    getCV() {
      if (this.$route.params.cv !== undefined && this.$route.params.cv !== null) {
        this.username = this.$route.params.cv.username;
        CandidatesDataService.getCV(this.$route.params.cv.cvId).then(
          (response) => {
            if (response.status == 200) {
              this.education = [];
              this.workExperience = [];
              this.skills = [];
              this.certifications = [];

              if (
                response.data.data['education'] !== undefined &&
                response.data.data['education'] !== null &&
                response.data.data['education'] !== 'No information available' &&
                Array.isArray(response.data.data['education']) &&
                response.data.data['education'].length > 0
              ) {
                response.data.data['education'].forEach((item) => {
                  const education = {};
                  education.date = item['date'] || null;
                  education.institution = item['academic_institution'] || null;
                  education.title = item['academic_title'] || null;

                  this.education.push(education);
                });
              }

              if (
                response.data.data['work_experience'] !== undefined &&
                response.data.data['work_experience'] !== null &&
                response.data.data['work_experience'] !== 'No information available' &&
                Array.isArray(response.data.data['work_experience']) &&
                response.data.data['work_experience'].length > 0
              ) {
                response.data.data['work_experience'].forEach((item) => {
                  const job = {};
                  job.position = item['position'] || null;
                  job.functions = item['functions'] || null;
                  job.company = item['company'] || null;
                  job.date = item['date'] || null;
                  job.place = item['city_country'] || null;
                  job.duration = item['duration'] || null;

                  this.workExperience.push(job);
                });
              }

              if (
                response.data.data['tools_and_skills'] !== undefined &&
                response.data.data['tools_and_skills'] !== null &&
                response.data.data['tools_and_skills'] !== 'No information available' &&
                Array.isArray(response.data.data['tools_and_skills']) &&
                response.data.data['tools_and_skills'].length > 0
              ) {
                response.data.data['tools_and_skills'].forEach((item) => {
                  const skill = {};

                  if (item['level'] !== null && item['level'] !== undefined && item['level'] !== '')
                    skill.level = item['level'];
                  else skill.level = null;

                  if (item['skill'] !== null && item['skill'] !== undefined && item['skill'] !== '')
                    skill.name = item['skill'];
                  else if (
                    item['lang'] !== null &&
                    item['lang'] !== undefined &&
                    item['lang'] !== ''
                  )
                    skill.name = item['lang'];
                  else skill.name = null;

                  if (skill.name !== null) this.skills.push(skill);
                });
              }

              if (
                response.data.data['certificates'] !== undefined &&
                response.data.data['certificates'] !== null &&
                response.data.data['certificates'] !== 'No information available' &&
                Array.isArray(response.data.data['certificates']) &&
                response.data.data['certificates'].length > 0
              ) {
                response.data.data['certificates'].forEach((item) => {
                  const certification = {};

                  certification.date = item['date'] || null;
                  certification.institution = item['academic_institution'] || null;
                  certification.title = item['academic_title'] || null;

                  this.certifications.push(certification);
                });
              }
            } else {
              this.successfull = false;
              this.message =
                'An error has occurred retrieving CV information. Please, try again later.';
            }
          },
          (error) => {
            this.successfull = false;
            this.message =
              'An error has occurred retrieving CV information. Please, try again later.';
            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }
          }
        );
      } else {
        this.$router.push('/candidates');
      }
    },
    openFunctions(item) {
      this.showFunctions = true;
      this.itemToShow = { ...item };
    },
    openEdit() {
      this.itemToEdit = {
        education: [...this.education],
        work_experience: [...this.workExperience],
        certificates: [...this.certifications],
        tools_and_skills: [...this.skills],
      };

      this.editing = true;
    },
    openDeleteItem(type, item) {
      this.type = type;
      this.itemToDelete = { ...item };
      this.deleteDialog = true;
    },
    deleteItem() {
      if (this.type == 'skills') {
        const index = this.itemToEdit.tools_and_skills.findIndex((item) =>
          this.deepEqual(item, this.itemToDelete)
        );

        if (index !== -1) this.itemToEdit.tools_and_skills.splice(index, 1);
      } else if (this.type == 'certifications') {
        const index = this.itemToEdit.certificates.findIndex((item) =>
          this.deepEqual(item, this.itemToDelete)
        );

        if (index !== -1) this.itemToEdit.certificates.splice(index, 1);
      } else if (this.type == 'education') {
        const index = this.itemToEdit.education.findIndex((item) =>
          this.deepEqual(item, this.itemToDelete)
        );

        if (index !== -1) this.itemToEdit.education.splice(index, 1);
      } else if (this.type == 'workExperience') {
        const index = this.itemToEdit.work_experience.findIndex((item) =>
          this.deepEqual(item, this.itemToDelete)
        );

        if (index !== -1) this.itemToEdit.work_experience.splice(index, 1);
      }

      this.deleteDialog = false;
    },
    cancelEdit() {
      this.successfull = true;
      this.message = '';
      this.getCV();
      this.editing = false;
    },
    editInformation() {
      if (Array.isArray(this.itemToEdit.education) && this.itemToEdit.education.length > 0)
        this.itemToEdit.education.forEach((item) => {
          item['academic_title'] = item['title'];
          item['academic_institution'] = item['institution'];
          delete item['title'];
          delete item['institution'];
        });

      if (Array.isArray(this.itemToEdit.certificates) && this.itemToEdit.certificates.length > 0)
        this.itemToEdit.certificates.forEach((item) => {
          item['academic_title'] = item['title'];
          item['academic_institution'] = item['institution'];
          delete item['title'];
          delete item['institution'];
        });

      if (
        Array.isArray(this.itemToEdit.work_experience) &&
        this.itemToEdit.work_experience.length > 0
      )
        this.itemToEdit.work_experience.forEach((item) => {
          item['city_country'] = item['place'];
          delete item['place'];
        });

      if (
        Array.isArray(this.itemToEdit.tools_and_skills) &&
        this.itemToEdit.tools_and_skills.length > 0
      )
        this.itemToEdit.tools_and_skills.forEach((item) => {
          item['skill'] = item['name'];
          delete item['name'];
        });

      CandidatesDataService.updateCV(this.$route.params.cv.cvId, this.itemToEdit).then(
        (response) => {
          if (response.status == 204) {
            this.getCV();
            this.message = 'CV information has been updated successfully.';
            this.successfull = true;
          } else {
            this.successfull = false;
            this.message =
              'An error has occurred updating CV information. Please, try again later.';
          }
          this.editing = false;
        },
        (error) => {
          this.successfull = false;
          this.message = 'An error has occurred updating CV information. Please, try again later.';
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
          this.editing = false;
        }
      );
    },
    deepEqual(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },
  },
};
</script>
